import { strapiBaseURL } from '../../../constants';
import { UploadType, UploadedMedia, RFile, RUploadedLink } from '../../types/Upload';
import { removeEmptyValues } from '../../utils';

type AllUploadTypes = UploadType.Image | UploadType.Document | UploadType.Weblink;

const mapFileType = (
    mimeType: string
): UploadType.Image | UploadType.Document | UploadType.Weblink => {
    if (mimeType.includes('image')) return UploadType.Image;
    else return UploadType.Document;
};

export const mapRFile = (rFile?: RFile): UploadedMedia<AllUploadTypes> | undefined => {
    if (!rFile) return undefined;

    const { id, documentId, url, alternativeText, caption, name, mime, size } = rFile;
    const type = mapFileType(mime);
    return {
        id,
        documentId,
        uniqueMediaId: `${type}_${documentId}`,
        type,
        name,
        url: `${strapiBaseURL}${url}`,
        description: alternativeText ?? undefined,
        source: caption ?? undefined,
        size
    };
};

export const mapRFiles = (remoteFiles?: RFile[] | null): UploadedMedia<AllUploadTypes>[] => {
    if (!remoteFiles || remoteFiles.length === 0) return [];
    return removeEmptyValues(remoteFiles.map(mapRFile));
};

export const mapRImage = (rFile?: RFile | null): UploadedMedia<UploadType.Image> | undefined => {
    if (!rFile) return undefined;
    const { id, documentId, url, alternativeText, caption, name, size } = rFile;

    return {
        id,
        documentId,
        uniqueMediaId: `${UploadType.Image}_${documentId}`,
        type: UploadType.Image,
        name,
        url: `${strapiBaseURL}${url}`,
        description: alternativeText ?? undefined,
        source: caption ?? undefined,
        size
    };
};

export const mapRImages = (remoteFiles?: RFile[] | null): UploadedMedia<UploadType.Image>[] => {
    if (!remoteFiles || remoteFiles.length === 0) return [];
    return removeEmptyValues(remoteFiles.map(mapRImage));
};

export const mapRLinks = (
    remoteLinks: RUploadedLink[] | undefined
): UploadedMedia<UploadType.Weblink>[] => {
    if (!remoteLinks) return [];

    return remoteLinks.map(({ id, documentId, url, description, source }) => ({
        id,
        documentId,
        uniqueMediaId: `${UploadType.Weblink}_${documentId}`,
        type: UploadType.Weblink,
        url,
        description: description ?? undefined,
        source: source ?? undefined
    }));
};
